import request from '@/api/request.js';

// 退费工单列表
export const getRefundWorkDataListPage = (data) => {
    return request({
        url: '/order/adm/refundWorkData/getListPage',
        method: 'post',
        type: 'json',
        data
    })
}

// 创建退费订单
export const createWorkData = (data) => {
    return request({
        url: '/order/adm/refundWorkData/createWorkData',
        method: 'post',
        type: 'json',
        data
    })
}

// 编辑退费订单
export const updateWorkData = (data) => {
    return request({
        url: '/order/adm/refundWorkData/updateWorkData',
        method: 'post',
        type: 'json',
        data
    })
}

// 取消退费
export const cancelRefundWorkData = (data) => {
    return request({
        url: '/order/adm/refundWorkData/cancelRefundWorkData',
        method: 'post',
        type: 'json',
        data
    })
}

// 退费工单详情
export const getRefundWorkData = (data) => {
    return request({
        url: '/order/adm/refundWorkData/getRefundWorkData',
        method: 'post',
        type: 'json',
        data
    })
}

// 操作日志
export const getworkLogListPage = (data) => {
    return request({
        url: '/order/adm/workLog/getListPage',
        method: 'post',
        type: 'json',
        data
    })
}

// 退费处理
export const saveReceiptImg = (data) => {
    return request({
        url: '/order/adm/refundWorkData/saveReceiptImg',
        method: 'post',
        type: 'json',
        data
    })
}

// 工单驳回
export const rejectRefundWorkData = (data) => {
    return request({
        url: '/order/adm/refundWorkData/reject',
        method: 'post',
        type: 'json',
        data
    })
}
